import { Avatar, Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import { allIcons } from "../../../assets";
import appcolors from "../../../constants/Colors";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_cs_pr": {
    fontWeight: 700,
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: "4rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      //   textAlign: "left",
    },
  },

  "& .lpl_cs_gr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  "& .lpl_cscard_con": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    border: `2px solid ${appcolors.primary}`,
    borderRadius: 12,
    padding: "20px 10px",
    height: 420,
    overflow: "hidden",
    margin: "0px 8px",
  },
  "& .lpl_cscard_image": {
    height: 90,
    width: 90,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
    padding: 25,
  },
  "& .lpl_cscard_title": {
    fontWeight: 700,
    fontSize: "1.5rem",
    position: "relative",
    display: "inline-block",
    paddingBottom: "10px",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "5px",
      backgroundImage: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    },
  },
}));

let renderData = [
  {
    icon: allIcons.microphoneIcon,
    title: "Manage",
    description:
      "Our SAAS system offers an intuitive B2B dashboard designed for salon and spa management. Effortlessly track appointments, manage staff schedules, and streamline inventory with user-friendly tools.",
  },
  {
    icon: allIcons.mobilephoneIcon,
    title: "Schedule",
    description:
      "Easily manage and organize appointments with our intuitive scheduling tool, designed to minimize conflicts and maximize efficiency. Stay on top of your calendar with automated reminders and real-time updates.",
  },
  {
    icon: allIcons.hourIcon,
    title: "Functionality",
    description:
      "Our SAAS system offers a comprehensive suite of functionalities tailored for salon and spa management, including appointment scheduling, staff management, inventory control management.",
  },
  {
    icon: allIcons.hourIcon,
    title: "Reduce No Shows",
    description:
      "Reduce no-shows with our SAAS system's automated reminders and confirmation notifications. Clients receive timely SMS or email reminders, ensuring they don't forget their appointments.",
  },
];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

function ChooseUs() {
  const renderCards = (data) => {
    return (
      // <Grid container spacing={2} justifyContent={"center"}>
      data?.map((val, index) => {
        return (
          // <Grid key={index} item xs={12} sm={6} md={3}>
          <Box className={"lpl_cscard_con"}>
            <Avatar src={val.icon} className="lpl_cscard_image" />
            <Typography my={2} variant={"h1"} className="lpl_cscard_title">
              {val.title}
            </Typography>
            <Typography my={2} variant={"body1"} color={"#747677"} p={2}>
              {val.description}
            </Typography>
          </Box>
          // </Grid>
        );
      })
      // </Grid>
    );
  };

  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Typography variant="h1" className="lpl_cs_pr">
        See Why Companies <span className="lpl_cs_gr"> Choose Us</span>
      </Typography>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlaySpeed={3000}
        arrows={true}
      >
        {renderCards(renderData)}
      </Carousel>
    </MainView>
  );
}

export default ChooseUs;
